// extracted by mini-css-extract-plugin
module.exports = {"KnowPointsCard":"KnowPointsCard_KnowPointsCard__Cm2vP","Title":"KnowPointsCard_Title__Sq0Ru","Points":"KnowPointsCard_Points__7qkiP","Image":"KnowPointsCard_Image__tpX3N"};